import * as modifierTypes from 'constants/modifiers';

export function getModifierMinSelections(modifier) {
  return Math.min(
    getModifierMaxSelections(modifier) || Number.MAX_VALUE,
    Math.max(modifier.min_selections || 0, modifier.mandatory ? 1 : 0),
  );
}

export function getModifierMaxSelections(modifier) {
  if (!modifier) return 0;
  if (modifier.max_selections != null) {
    return modifier.max_selections;
  }
  if (modifier.modifier_type === modifierTypes.Single_Selected) {
    return 1;
  }
  return 0;
}

export function optionsHasChildren(option) {
  return option.modifiers_children?.length > 0;
}

export function getModifierSelectionsText(modifier) {
  const maxSelections = getModifierMaxSelections(modifier);
  const minSelections = getModifierMinSelections(modifier);
  const supportMultipleQuantity = modifier.options.some((o) => o.supports_multiple_quantity);

  if (!minSelections && !maxSelections) {
    return null;
  }

  if (maxSelections === minSelections) {
    return `Select ${maxSelections}`;
  }
  if (!minSelections && !maxSelections) {
    return null;
  }
  let texts = '';
  if (minSelections > 0) {
    texts += `Select at least ${minSelections}`;
  }
  if (maxSelections > 1) {
    texts += texts ? ', ' : 'Select ';
    texts += `up to ${supportMultipleQuantity ? maxSelections : Math.min(modifier.options.length, maxSelections)}`;
  }
  return texts;
}

export function isMultiSelect(modifier) {
  const maxSelection = getModifierMaxSelections(modifier);
  if (maxSelection === 1) {
    return false;
  }
  return (
    modifier.modifier_type === modifierTypes.Multi_Selected ||
    isAutoApplied(modifier) ||
    getModifierMinSelections(modifier) > 1 ||
    maxSelection > 1
  );
}

export function isAutoApplied(modifier) {
  return modifier.modifier_type === modifierTypes.Auto_Applied;
}

export function sortModifierOptions(item) {
  return {
    ...item,
    modifiers: item.modifiers?.map(sort),
  };

  function sort(modifier) {
    return {
      ...modifier,
      options: modifier.options.sort((a, b) => a.position - b.position),
    };
  }
}
